module.exports = __webpack_public_path__ + "static/media/stripe.848eae3b.svg";